<h1 mat-dialog-title><strong>Création d'un Candidat</strong></h1>

<form #f="ngForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <div class="input-group">
      <mat-form-field>
        <mat-label>Prénom</mat-label>
        <input
          matInput
          type="text"
          name="firstname"
          [(ngModel)]="candidate.firstName"
          #firstName="ngModel"
          [ngClass]="{ 'is-invalid': firstName.invalid && (firstName.dirty || firstName.touched) }"
          pattern="^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,}$"
          required />
        <div class="invalid-feedback">
          @if (firstName.errors?.['required']) {
          <span>Veuillez saisir votre prénom.</span>
          } @if (firstName.errors?.['pattern']) {
          <span>Veuillez saisir un prénom valide.</span>
          }
        </div>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Nom</mat-label>
        <input
          matInput
          type="text"
          name="lastname"
          [(ngModel)]="candidate.lastName"
          #lastname="ngModel"
          [ngClass]="{ 'is-invalid': lastname.invalid && (lastname.dirty || lastname.touched) }"
          pattern="^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,}$"
          required />
        <div class="invalid-feedback">
          @if (lastname.errors?.['required']) {
          <span>Veuillez saisir votre nom.</span>
          } @if (lastname.errors?.['pattern']) {
          <span>Veuillez saisir un nom valide.</span>
          }
        </div>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Email</mat-label>
        <input
          matInput
          type="email"
          name="email"
          [(ngModel)]="candidate.email"
          #email="ngModel"
          [ngClass]="{ 'is-invalid': email.invalid && (email.dirty || email.touched) }"
          email
          required />
        <div class="invalid-feedback">
          @if (email.errors?.['required']) {
          <span>Veuillez saisir votre email.</span>
          } @if (email.errors?.['email']) {
          <span>Veuillez saisir un email valide.</span>
          }
        </div>
      </mat-form-field>
    </div>

    <div class="d-flex flex-row">
      @if (send) {
      <div class="spinner-border text-primary ms-2" style="width: 2rem; height: 2rem" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      }
    </div>
  </div>
  <mat-dialog-actions class="justify-content-end">
    <button mat-raised-button mat-dialog-close>Annuler</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="f.invalid || !dateCondition">Envoyer</button>
  </mat-dialog-actions>
</form>
